import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiStepsSectionDTO,
  StepsSectionDTO,
} from "@lib/strapi/dtos/components/sections/stepsSection.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { StepService } from "@lib/strapi/services/components/shared/step.service";

export class StepsSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiStepsSectionDTO,
  ): Promise<StepsSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new StepsSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.heading = strapiData.heading;
    dto.intro = await parseStrapiContent(strapiData.intro);
    dto.steps = await Promise.all(
      (strapiData.steps ?? []).map(
        async (item) => await StepService.fromStrapi(locale, item),
      ),
    );
    return dto;
  }
}
